import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { SignInView } from "./views/SignInView";
import { AppShell } from "./views/AppShell";
import { ProjectsView } from "./views/ProjectsView";
import { ProjectDetailView } from "./views/ProjectDetailView";
import { RoomDetailView } from "./views/RoomDetailView";
import { ScanDetailView } from "./views/ScanDetailView";
import { SplatInspectorView } from "./views/SplatInspectorView";
import { SplatModelsView } from "./views/SplatModelsView";
import { ObjectsView } from "./views/ObjectsView";
import { ObjectDetailView } from "./views/ObjectDetailView";
import { SessionGalleryView } from "./views/SessionGalleryView";
import { IdeabookView } from "./views/IdeabookView";
import { MakeoverView } from "./views/MakeoverView";
import { JoinInviteView } from "./views/JoinInviteView";

export function App() {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center text-muted">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
      </div>
    );
  }

  // /join/:token sits ABOVE the auth gate: the invite landing page must render
  // its unauthenticated preview (and the sign-in-to-join flow) for signed-out
  // visitors instead of bouncing them to the generic sign-in screen.
  return (
    <Routes>
      <Route path="/join/:token" element={<JoinInviteView />} />
      <Route path="/*" element={status === "signedOut" ? <SignInView /> : <SignedInApp />} />
    </Routes>
  );
}

function SignedInApp() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<ProjectsView />} />
        <Route path="/projects/:projectId" element={<ProjectDetailView />} />
        <Route path="/rooms/:roomId" element={<RoomDetailView />} />
        <Route path="/rooms/:roomId/makeover" element={<MakeoverView />} />
        <Route path="/rooms/:roomId/sessions/:sessionId" element={<SessionGalleryView />} />
        <Route path="/rooms/:roomId/ideabook" element={<IdeabookView />} />
        <Route path="/scans/:scanId" element={<ScanDetailView />} />
        <Route path="/scans/:scanId/splat" element={<SplatInspectorView />} />
        <Route path="/splats/:jobId/splat" element={<SplatInspectorView />} />
        <Route path="/models" element={<SplatModelsView />} />
        <Route path="/objects" element={<ObjectsView />} />
        <Route path="/objects/:objectId" element={<ObjectDetailView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
